module.exports = __webpack_public_path__ + "img/siddeti-onleme-ve-insan-haklari-danismanligi.945f8ec7.jpg";